<template lang="pug">
  div(class="e-document-tag") {{ name }}
</template>

<script>
export default {
  name: 'EDocumentTag',
  props: {
    name: {
      type: String,
      default: null,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.e-document-tag {
  padding: 4px 6px;
  border-radius: 6px;
  background: $background-secondary-alternative;

  color: #121212;
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 50px;
}
</style>
